<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <img
            :src="profile.picture_url"
            class="c-avatar-img "
          />
        </div>
      </CHeaderNavLink>
    </template>
    
    <CDropdownHeader
      tag="div"
      class="text-center"
      color="light"
    >
      <strong>Einstellungen</strong>
    </CDropdownHeader>
    <CDropdownItem @click="gotoprofile">
      <CIcon name="cil-user" /> Profil
    </CDropdownItem>
    <CDropdownItem @click="gotosettings">
      <CIcon name="cil-settings" /> Einstellungen
    </CDropdownItem>
    
    <CDropdownDivider/>

    <CDropdownItem  @click="logout">
      <CIcon name="cil-lock-locked" /> Logout
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import { AUTH_LOGOUT } from "../store/actions/auth";
//import store from '../store';
import { mapGetters} from "vuex";

export default {
  name: 'TheHeaderDropdownAccnt',
  computed : mapGetters(["profile"]),
  data () {
    return { 
      itemsCount: 42
    }
  },
  methods: {
    gotoprofile() {
      this.$router.push('/users/'+this.profile.id);
    },

    gotosettings() {alert('Keine Einstellungen möglich');},

    logout() {
     this.$store.dispatch(AUTH_LOGOUT)
     .then(() => {
        this.$router.push('/login')
     })
    }
  } 
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>